/**
 * The menu tree, as `GET /api/v1/navigation/me/` returns it.
 *
 * Already filtered by the caller's permissions on the server: empty groups are
 * gone and single-child groups are flattened, so the client renders what it
 * receives and makes no visibility decision of its own. Labels are domain
 * content RR.HH. edits at runtime — they come from here, never from i18n.
 */
import { apiClient } from '@/api/client';

export interface MenuNode {
  code: string;
  label: string;
  /** A lucide icon name in kebab-case; unknown names fall back to a neutral glyph. */
  icon: string;
  /** `null` for a group. */
  path: string | null;
  mobile_priority: number | null;
  children: MenuNode[];
}

export async function fetchMyMenu(): Promise<MenuNode[]> {
  const { data } = await apiClient.get<MenuNode[]>('/api/v1/navigation/me/');
  return data;
}
